import * as React from 'react';
import { Button, Radio } from '@cian/ui-kit';
import { useDeviceType } from '@cian/ui-kit/responsive';
import * as styles from './styles.css';

import { INameValueObj } from '../../../../../../types/nameValue';
import { EDealTypeEx } from '../../../../../../constants/dealTypeEx';

export interface IDealTypeQuestionProps {
  selectedValue: EDealTypeEx | undefined;
  options: INameValueObj[];
  submitText: string;

  onChange(value: string): void;

  onSubmit(value: EDealTypeEx): void;
}

export const ChoseDealType: React.FC<IDealTypeQuestionProps> = ({
  options,
  selectedValue,
  onSubmit,
  onChange,
  submitText,
}) => {
  const isMobile = useDeviceType() === 'phone';
  const handleChange = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      onChange(e.currentTarget.value);
    },
    [onChange],
  );

  const handleSubmit = React.useCallback(() => {
    onSubmit(selectedValue as EDealTypeEx);
  }, [selectedValue, onSubmit]);

  return (
    <div className={styles['container']}>
      {options.map(({ name, value }) => (
        <div key={value} className={styles['option']}>
          <Radio
            name="demandValuation"
            value={value}
            label={name}
            checked={selectedValue === value}
            onChange={handleChange}
          />
        </div>
      ))}
      <div className={styles['action']}>
        <Button size={isMobile ? 'M' : 'XS'} onClick={handleSubmit} disabled={!selectedValue}>
          {submitText}
        </Button>
      </div>
    </div>
  );
};

ChoseDealType.displayName = 'ChoseDealType';
